// extracted by mini-css-extract-plugin
export var container = "footer-module--container--29F0B";
export var contact = "footer-module--contact--4BxwS";
export var developer = "footer-module--developer--CVzjA";
export var icon = "footer-module--icon--V_cj-";